import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { useRouter } from "next/router";
import { KeyboardEvent as ReactKeyboardEvent } from "react";

import { useEffect, useRef, useState } from "react";

export function SearchBar({ className }: { className?: string }) {
  const [input, setInput] = useState("");
  const router = useRouter();
  const inputRef = useRef<HTMLInputElement>(null);

  function handleSearch() {
    if (input === "") return;
    if (/^\d+$/.test(input)) {
      router.push("/nonce/" + input.trim());
    } else {
      router.push("/hash/" + input.trim());
    }
  }

  function handleInput(e: ReactKeyboardEvent) {
    if (e.key === "Enter") {
      handleSearch();
    }
  }

  // Focus search bar when pressing /
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e?.target as Element)?.nodeName === "BODY" && e.key === "/") {
        e.preventDefault();
        if (inputRef.current !== null) inputRef.current.focus();
      }
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });
  return (
    <div className={className}>
      <label htmlFor="search" className="sr-only">
        Search by nonce or hash
      </label>
      <div className="relative w-full flex-1 text-gray-400 focus-within:text-gray-600">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <MagnifyingGlassIcon className="mb-1 h-5 w-5" aria-hidden="true" />
        </div>
        <input
          ref={inputRef}
          id="search"
          className="block w-full rounded-md border border-transparent bg-white py-2 pl-10 pr-3 leading-5 text-gray-900 placeholder-gray-500 transition-[width] focus:border-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-succinct-black sm:text-sm md:text-base"
          placeholder="Search by nonce or hash"
          type="search"
          inputMode="search"
          name="search"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleInput}
          onSubmit={handleSearch}
        />
      </div>
    </div>
  );
}
